var $e98983e40b8886ed$exports = {};
$e98983e40b8886ed$exports = {
    "collectionLabel": `\u{5EFA}\u{8BAE}`
};


export {$e98983e40b8886ed$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
